import React, { ReactElement, ReactNode } from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

// Define the props interface
interface CustomTooltipProps {
    title: string;
    children: ReactElement; // children can be any valid React element or node
    tooltipProps?: Partial<TooltipProps>;
}

const CustomTooltip = ({ title, children, tooltipProps }: CustomTooltipProps) => {
    return (
        <Tooltip
            {...tooltipProps}
            title={title}
            arrow
            slotProps={{
                tooltip: {
                    sx: {
                        color: "black",
                        backgroundColor: "#F8FCFF",
                        borderRadius: '0px',
                        border: '1px solid #E1E1E1',
                        zIndex: 100,
                        width: '200px',
                        maxWidth: 'none',
                        overflowWrap: 'anywhere'
                    },
                },
                arrow: {
                    sx: {
                        color: "#F8FCFF",
                    },
                },
            }}
        >
            {children}
        </Tooltip>
    );
}

export default CustomTooltip;
